__turbopack_context__.v({
  "price": "monthly-prices-module__n_TcYW__price",
  "price-wrapper": "monthly-prices-module__n_TcYW__price-wrapper",
  "text": "monthly-prices-module__n_TcYW__text",
  "wrapper": "monthly-prices-module__n_TcYW__wrapper",
});
